import React, {useState, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Redirect} from 'react-router-dom';

import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import CheckButton from 'react-validation/build/button';
import {Link} from 'react-router-dom';
import {EyeInvisibleOutlined, EyeOutlined} from '@ant-design/icons';
import Turnstile from '../Turnstile/Turnstile';

import {login} from '../../actions/auth';
import './LoginForm.css';
import {message, Alert} from 'antd';

const required = value => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        This field is required!
      </div>
    );
  }
};

const LoginForm = props => {
  const form = useRef ();
  const checkBtn = useRef ();

  const [username, setUsername] = useState ('');
  const [password, setPassword] = useState ('');
  const [loading, setLoading] = useState (false);
  const [isShown, setIsShown] = useState (false);
  const [turnstileToken, setTurnstileToken] = useState ('');
  const [turnstileReset, setTurnstileReset] = useState (0);
  const {isLoggedIn} = useSelector (state => state.auth);
  const {message: CurrentMessage} = useSelector (state => state.message);
  const dispatch = useDispatch ();

  const onChangeUsername = e => {
    const uname = e.target.value;
    setUsername (uname);
  };
  const onChangePassword = e => {
    const password = e.target.value;
    setPassword (password);
  };

  const handleLogin = async e => {
    e.preventDefault ();

    setLoading (true);

    if (!turnstileToken) {
      message.error ('Please complete the Turnstile verification.');
      setLoading (false);
      return;
    }

    form.current.validateAll ();

    if (checkBtn.current.context._errors.length === 0) {
      dispatch (login (username, password, turnstileToken))
        .then (() => {
          props.history.push ('/profile/codersarts-dashboard-home');
          window.location.reload ();
        })
        .catch (() => {
          setTurnstileToken ('');
          setTurnstileReset (prevValue => prevValue + 1);
          setLoading (false);
        });
    } else {
      setLoading (false);
    }
  };

  if (isLoggedIn) {
    return <Redirect to="/profile/codersarts-dashboard-home" />;
  }

  return (
    <div className="loginForm auth-screen">
      <div className="auth-card card card-container">
        <div className="auth-header">
          <h1>Welcome back</h1>
          <p>Log in to your Codersarts dashboard</p>
        </div>

        <Form onSubmit={handleLogin} ref={form}>
          <div className="form-group auth-field">
            <label htmlFor="username">Email or username</label>
            <Input
              type="text"
              className="form-control"
              name="username"
              value={username}
              onChange={onChangeUsername}
              validations={[required]}
              placeholder="you@codersarts.com"
            />
          </div>

          <div className="form-group auth-field">
            <div className="auth-label-row">
              <label htmlFor="password">Password</label>
              <Link to="/auth/signin/forget-password">Forgot password?</Link>
            </div>
            <div className="auth-password-wrap">
              <Input
                type={isShown ? 'text' : 'password'}
                className="form-control input-password"
                name="password"
                value={password}
                onChange={onChangePassword}
                validations={[required]}
                placeholder="Password"
              />
              {isShown
                ? <span
                    onClick={() => {
                      setIsShown (prevValue => !prevValue);
                    }}
                    className="eye-icon"
                  >
                    <EyeOutlined style={{fontSize: '18px'}} />{' '}
                  </span>
                : <span
                    onClick={() => {
                      setIsShown (prevValue => !prevValue);
                    }}
                    className="eye-icon"
                  >
                    <EyeInvisibleOutlined style={{fontSize: '18px'}} />
                  </span>}
            </div>
          </div>

          <div className="form-group auth-turnstile">
            <Turnstile
              resetSignal={turnstileReset}
              onVerify={setTurnstileToken}
              onExpire={() => setTurnstileToken ('')}
              onError={() => setTurnstileToken ('')}
            />
          </div>

          <div className="form-group auth-actions">
            <button
              className="btn btn-primary btn-block"
              disabled={loading || username === '' || password === '' || !turnstileToken}
            >
              {loading && <span className="spinner-border spinner-border-sm" />}
              <span>Log in</span>
            </button>
            <div className="login__footer__link auth-footer-link">
              <span>Don't have an account?</span>
              <Link to="/auth/signup">Sign up</Link>
            </div>

          </div>

          {CurrentMessage && <Alert message={CurrentMessage} type="error" showIcon />}
          <CheckButton style={{display: 'none'}} ref={checkBtn} />
        </Form>
      </div>
    </div>
  );
};

export default LoginForm;
